import { Company } from "interfaces/Company";
import { get, patch, post, remove } from "services/services.methods";
import { CompanyPaths } from "services/services.paths";

export const getCompanys = async () => {
  const response = await get<Company[]>(CompanyPaths.get);

  return response;
};


export const CreateCompanys = async (data: any) => {
  const response = post<any>(CompanyPaths.post, data);
  return response;
};


export const UpdateCompanys = async (id: number, data: any) => {
  const response = await patch<Company>(
    CompanyPaths.put + `/${id}`, data);

  return response;
};

export const DeleteCompanys = async (id: number) => {
  const response = await remove<Company[]>(
    CompanyPaths.delete + `/${id}`
  );
  return response;
};